import { Injectable } from '@angular/core';
import { CanActivate, CanLoad } from '@angular/router';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReseteoGuard implements CanActivate, CanLoad {

  constructor(
    private translate: TranslateService
    , private nav: NavController
  ) { }

  canLoad(): Observable<boolean> {
    return combineLatest([this.translate.get('Miscellaneous.view-reset-home'), this.translate.get('Miscellaneous.view-reset-modal')])
      .pipe(
        map((estado: [boolean, boolean]) => !(!estado[0] && !estado[1])),
        tap(estado => {
          if (!estado) {
            this.nav.back();
          }
        }),
        take(1)
      );
  }

  canActivate(): Observable<boolean> {
    return combineLatest([this.translate.get('Miscellaneous.view-reset-home'), this.translate.get('Miscellaneous.view-reset-modal')])
      .pipe(
        map((estado: [boolean, boolean]) => !(!estado[0] && !estado[1])),
        tap(estado => {
          if (!estado) {
            this.nav.back();
          }
        }),
      );
  }

}
